import { Tag } from '../Tag';

type Props = {
  /** タグのリスト。 */
  tags: string[];
};

export const TagList = ({ tags }: Props) => {
  return (
    <div className="flex flex-wrap gap-[16px]">
      {tags.map((tag, index) => (
        <Tag key={index} value={tag} />
      ))}
    </div>
  );
};
